import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { asChakraVariable, themeColorSectionKeys } from '~/themes/colors/colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const {
  Background: { Page: PageColor },
  BoxShadow: BoxShadowDefaultColor,
} = themeColorSectionKeys.defaults

export enum ListPanelVariants {
  Open = 'open',
  Closed = 'closed',
}

const PANEL_WIDTH = '22rem'

const ListPanelParts = ['staticContainer', 'slidingContainer'] as const

const helpers = createMultiStyleConfigHelpers(ListPanelParts)

export const ListPanelStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    staticContainer: {
      flexDirection: 'column',
      flexShrink: 0,
      alignItems: 'flex-start',
      width: PANEL_WIDTH,
      height: 'full',
      backgroundColor: PageColor,
    },
    slidingContainer: {
      flexDirection: 'column',
      shrink: 0,
      alignItems: 'flex-start',
      width: PANEL_WIDTH,
      minWidth: 0,
      height: 'full',
      backgroundColor: PageColor,
      zIndex: 3,
      transition: 'all 0.25s ease-in-out',
      boxShadow: 'none',
    },
  },
  variants: {
    [ListPanelVariants.Open]: {
      slidingContainer: {
        left: 0,
        boxShadow: `1rem 0 0.75rem -0.75rem ${asChakraVariable(
          BoxShadowDefaultColor,
        )}`,
      },
    },
    [ListPanelVariants.Closed]: {
      slidingContainer: {
        left: `-${PANEL_WIDTH}`,
      },
    },
  },
  defaultProps: {
    variant: ListPanelVariants.Open,
  },
})

export const useListPanelStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ListPanelParts>(
    getName({ ListPanelStyle }),
    props,
  )
}
